// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "javascript/chunks/" + "6f1c33916f350038bbe7" + ".min.js";
};